import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createPurInwEntry = createAsyncThunk('createPurInwEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPI`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const createDirectPurInwEntry = createAsyncThunk('createDirectPurInwEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPIDirect`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPurInwardData = createAsyncThunk('fetchPurInwardData', async (id) => {
    try {
        const endpoint = id ? `getPIlist&piId=${id}` : 'getPIlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});



export const fetchPINo = createAsyncThunk('fetchPINo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getbarPIno`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deletePI = createAsyncThunk('deletePI', async (Ids) => {
    const { purId, clothId, pInfoId } = Ids;
    try {
        const response = await axios.get(`${baseUrl}?apicall=deletePI&purId=${purId}&clothId=${clothId}&pInfoId=${pInfoId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});




const purInwardSlice = createSlice({
    name: 'PurchaseInwardData',
    initialState: {
        isLoading: false,
        purchaseinward: null,
        piNo: null,
        deletePurInward: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPurInwardData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPurInwardData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.purchaseinward = action.payload;
        });
        builder.addCase(fetchPurInwardData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPINo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPINo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.piNo = action.payload;
        });
        builder.addCase(fetchPINo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deletePI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deletePI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deletePurInward = action.payload;
        });
        builder.addCase(deletePI.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


    }
});

export default purInwardSlice.reducer;
